import { render, staticRenderFns } from "./TourTabsExtras.vue?vue&type=template&id=53dbc2a2&scoped=true&"
import script from "./TourTabsExtras.vue?vue&type=script&lang=js&"
export * from "./TourTabsExtras.vue?vue&type=script&lang=js&"
import style0 from "./TourTabsExtras.vue?vue&type=style&index=0&id=53dbc2a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dbc2a2",
  null
  
)

export default component.exports